/**
 * @author yan st
 * @date 2022-08-16 08:40
 * @Description:
 */
import { qspost, postfile } from "@/plugins/axiosAdmin";

/*
 *   账号登录
 * */
export const adminLogin = (username, password, code, key) =>
  qspost("/admin/Login/adminLogin", { username, password, code, key });

/*
 *  获取验证码
 * */
export const verify = () => qspost("/verify", {});

/*
 *  注册
 * */
export const organRegister = (username, password, organ_name, code, key) =>
  qspost("/api/Organ/organRegister", {
    username,
    password,
    organ_name,
    code,
    key,
  });

/*
 * 找回密码
 * */
export const findPass = (phone, code, pass, repass) =>
  qspost("/api/index/findPass", {
    phone,
    code,
    pass,
    repass,
  });

/*
 *   管理员详情
 * */
export const getAdminDetail = () => qspost("/admin/Admin/getAdminDetail", {});

/*
 *   项目申报分页列表
 * */
export const getProjectList = (
  keyword,
  organ_id,
  approve_status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  pageIndex,
  pageSize
) =>
  qspost("/admin/Project/getProjectList", {
    keyword,
    organ_id,
    approve_status,
    begin_time,
    end_time,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
    pageIndex,
    pageSize,
  });

/*
 *   导出项目列表
 * */
export const exportProjectList = (
  keyword,
  organ_id,
  approve_status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  type = 1
) =>
  postfile(
    "/admin/Project/" +
      (type === 1 ? "exportProjectList" : "exportProjectList2"),
    {
      keyword,
      organ_id,
      approve_status,
      begin_time,
      end_time,
      project_class,
      project_direction,
      organ_class,
      province_id,
      city_id,
      type,
    }
  );

/*
 *   区 导出excel表格
 * */
export const exportProjectExcel = (
  keyword,
  organ_id,
  approve_status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  type = 1
) =>
  postfile("/admin/Project/exportProjectExcel", {
    keyword,
    organ_id,
    approve_status,
    begin_time,
    end_time,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
    type,
  });

/*
 *   项目申报分页列表
 * */
export const getApproveProjectList = (
  type,
  keyword,
  organ_id,
  approve_status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  pageIndex,
  pageSize
) =>
  qspost("/admin/Project/getApproveProjectList", {
    type,
    keyword,
    organ_id,
    approve_status,
    begin_time,
    end_time,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
    pageIndex,
    pageSize,
  });

/*
 *   申报项目详情
 * */
export const getProjectDetail = (project_id) =>
  qspost("/admin/Project/getProjectDetail", {
    project_id,
  });

/*
 *   机构列表
 * */
export const getOrganPassList = () =>
  qspost("/admin/Organ/getOrganPassList", {});

/*
 *  机构分页列表
 * */
export const getOrganList = (keyword,  begin_time, end_time, pageIndex, pageSize) =>
  qspost("/admin/Organ/getOrganList", {
    keyword,
    begin_time,
    end_time,
    pageIndex,
    pageSize,
  });

/*
 *   机构列表
 * */
export const index = () => qspost("/admin/Index/index", {});

/*
 *   初审评分
 * */
export const projectScoreList = (type) =>
  qspost("/admin/Index/projectScoreList", {
    type,
  });

/*
 *   初审评分
 * */
export const getProjectScoreInfo = (project_id, type) =>
  qspost("/admin/Project/getProjectScoreInfo", {
    project_id,
    type,
  });

/*
 *   初审评分
 * */
export const getProjectScoreRecordInfo = (project_id, type, project_score_id) =>
  qspost("/admin/Project/getProjectScoreRecordInfo", {
    project_id,
    type,
    project_score_id,
  });

/*
 *   初审评分
 * */
export const projectScoreInfo = (
  type,
  project_id,
  score_list,
  reason,
  approve_status,
  is_save
) =>
  qspost("/admin/Project/projectScoreInfo", {
    type,
    project_id,
    score_list,
    reason,
    approve_status,
    is_save,
  });

/*
 *   保存机构信息
 * */
export const updateOrganInfo = (id, organ_name, username, password,phone) =>
  qspost("/admin/Organ/updateOrganInfo", {
    id,
    organ_name,
    username,
    password,
    phone
  });

/*
 *   项目申报信息审核
 * */
export const approveProjectInfo = (project_id, approve_status, refund_reason) =>
  qspost("/admin/Project/approveProjectInfo", {
    project_id,
    approve_status,
    refund_reason,
  });

/*
 *   修改管理员信息
 * */
export const updateAdminInfo = (project_id, approve_status, refund_reason) =>
  qspost("/admin/Admin/updateAdminInfo", {
    project_id,
    approve_status,
    refund_reason,
  });

/*
 *   编辑个人信息
 * */
export const updateAdminDetail = (nickname) =>
  qspost("/admin/Admin/updateAdminDetail", {
    nickname,
  });

/*
 *   撤回审核状态
 * */
export const exitProjectApprove = (project_id) =>
  qspost("/admin/Project/exitProjectApprove", {
    project_id,
  });

/*
 *   获取项目审核记录列表
 * */
export const getProjectApproveRecordList = (project_id) =>
  qspost("/admin/Project/getProjectApproveRecordList", {
    project_id,
  });

/*
 *   审核端-待分配项目列表
 * */
export const getCheckProjectList = (type) =>
  qspost("/admin/Project/getCheckProjectList", {
    type,
  });

/*
 *   管理员列表
 * */
export const getAdminList = (keyword, role_id, pageIndex, pageSize) =>
  qspost("/admin/Admin/getAdminList", {
    keyword,
    role_id,
    pageIndex,
    pageSize,
  });

/*
 *   日志列表
 * */
export const getLogList = (pageIndex, pageSize) =>
  qspost("/admin/Log/getLogList", {
    pageIndex,
    pageSize,
  });

/*
 *   审核端-获取项目方向列表
 * */
export const getProjectClassDirectionList = () =>
  qspost("/admin/Project/getProjectClassDirectionList", {});

/*
 *   管理员
 * */
export const insertAdminInfo = (
  id,
  nickname,
  username,
  password,
  role_type,
  role_id,
  project_direction,
  check_project_id,
  recheck_project_id,
  recheck_project_direction,
  mid_project_id,
  mid_project_direction
) =>
  qspost(id ? "admin/Admin/updateAdminInfo" : "/admin/Admin/insertAdminInfo", {
    id,
    nickname,
    username,
    password,
    role_type,
    role_id,
    project_direction,
    check_project_id,
    recheck_project_id,
    recheck_project_direction,
    mid_project_id,
    mid_project_direction,
  });

/*
 *   审核端-项目评分记录
 * */
export const getProjectScoreList = (project_id, type) =>
  qspost("/admin/Project/getProjectScoreList", {
    project_id,
    type,
  });

/*
 *   项目月报记录分页列表
 * */
export const getProjectReportList = (
  keyword,
  organ_id,
  status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  pageIndex,
  pageSize
) =>
  qspost("/admin/Project/getProjectReportList", {
    keyword,
    organ_id,
    status,
    begin_time,
    end_time,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
    pageIndex,
    pageSize,
  });

/*
 *   项目月报记录（补充资料）分页列表
 * */
export const getProjectFileList = (
  keyword,
  organ_id,
  status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  pageIndex,
  pageSize
) =>
  qspost("/admin/Project/getProjectFileList", {
    keyword,
    organ_id,
    status,
    begin_time,
    end_time,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
    pageIndex,
    pageSize,
  });

/*
 *  月报时间列表
 * */
export const getTimeList = () => qspost("/admin/Project/getTimeList", {});

/*
 *  项目月报详情
 * */
export const getProjectReportInfo = (data) =>
  qspost("/admin/Project/getProjectReportInfo", data);

/*
 *  保存项目月报详情
 * */
export const saveProjectReportInfo = (data) =>
  qspost("/admin/Project/saveProjectReportInfo", data);

/*
 *   导出月报记录
 * */
export const exportReportList = (
  keyword,
  organ_id,
  approve_status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  type = 1
) =>
  type === 1
    ? postfile("/admin/Project/exportReportList", {
        keyword,
        organ_id,
        approve_status,
        begin_time,
        end_time,
        project_class,
        project_direction,
        organ_class,
        province_id,
        city_id,
        type,
      })
    : qspost("/admin/Project/exportReportZip", {
        keyword,
        organ_id,
        approve_status,
        begin_time,
        end_time,
        project_class,
        project_direction,
        organ_class,
        province_id,
        city_id,
        type,
      });

/*
 *   导出月报记录（补充资料）
 * */
export const exportProjectFileList = (
  keyword,
  organ_id,
  approve_status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id
) =>
  qspost("/admin/Project/exportProjectFileList", {
    keyword,
    organ_id,
    approve_status,
    begin_time,
    end_time,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
  });

/*
 *   导出月报记录（补充资料）
 * */
export const exportEndProjectFileList = (
  keyword,
  organ_id,
  approve_status,
  begin_time,
  end_time,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id
) =>
  qspost("/admin/Project/exportEndProjectFileList", {
    keyword,
    organ_id,
    approve_status,
    begin_time,
    end_time,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
  });
